import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Payment, SignUpRequest, SignUpResponse, voidInvoiceRequest } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppErrors, BadRequestError, ForbiddenError, NotFoundError } from '@fitness-force/errors';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { NotificationChannels } from '@fitness-force/enum';


@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  getPaymentPDF(clientId: number, paymentId: number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENTS.GET_PAYMENT_PDF.replace('{client_id}', clientId.toString()).replace('{pymt_id}', paymentId.toString());
    return this.http.get(url).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  makePayment(tenantId: number, clientId: number, invoiceId: number, paymentRequest: Payment): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENTS.MAKE_PAYMENT.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{invoice_id}', invoiceId.toString());
    return this.http.post(url, paymentRequest, { headers: this.httpOptions.headers }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  voidPayment(tenantId: number, clientId: number, paymentId: number, voidRequest: voidInvoiceRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENTS.VOID_PAYMENT.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{pymt_id}', paymentId.toString());
    return this.http.post(url, voidRequest, { headers: this.httpOptions.headers }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        else if (error.status === 403) {
          return throwError(() => new ForbiddenError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SubscriptionSignup(tenant_id: number, client_id: number, signUpRequest: SignUpRequest)
    : Observable<SignUpResponse> {
    return this.http
      .post(`${environment.BASE_URL}/tenants/${tenant_id}/clients/${client_id}/subscription_signups`
        , signUpRequest
        , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



  SendPaymentPDF(clientId: number, paymentId: number, channels:any[]): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENTS.SEND_EMAIL.replace('{client_id}', clientId.toString()).replace('{pymt_id}', paymentId.toString());
    return this.http.post(url, channels,{
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getPaymentByPaymentId(clientId: number, paymentId: number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENTS.GET_PAYMENT_BY_ID.replace('{client_id}', clientId.toString()).replace('{pymt_id}', paymentId.toString());
    return this.http.get(url, { headers: this.httpOptions.headers }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }
}
